import React from 'react';
import ComplianceReportsSection from '../../../sections/AdminDashboard/VerificationCompliance/ComplianceReports';

const ComplianceReports = () => {
  return <ComplianceReportsSection />;
};

export default ComplianceReports;
